<template>
    <div >
        <date-range-picker
            v-model="content" 
            :locale-data="{ firstDay: 1, format: dateFormat }"
            :time-picker="customData.daterange.timePicker"
            :time-picker24-hour="!customData.daterange.is12h"
            :time-picker-increment="customData.daterange.minuteStep"
            :min-date="minDate"
            :max-date="maxDate"
            :date-format="formatter"
            :auto-apply="true"
            single-date-picker="range"
            @toggle="toggle"
            @change-month="toggle"
        >
        </date-range-picker>
         <b-form-invalid-feedback :id="field.key" style="display:block">
          {{ errors[0] || null }}
        </b-form-invalid-feedback>
    </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
//you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { buildFiltersFromContext } from '../../utils/context'
import _ from 'lodash'
import moment from 'moment'

export default {
    name: "IdentityFieldDateRange",
    components: {
        DateRangePicker
    },
    props: {
        field: {
            type: Object
        },
        value: {
            type: Object,
            default: function() {
                return {
                    startDate: null,
                    endDate: null
                }
            }
        },
        store: {
            type: Object
        },
        context: {
            type: Object,
            default: function() {
                return {}
            }
        }
    },
    data: function() {
        return {
            errors: [],
            disabledDates: []
        }
    },
    watch: {
        content(val) {
            this.check(val)
        },

        "context.model": {
            handler: _.debounce(function(val, valOld) {
                if (JSON.stringify(val) != JSON.stringify(valOld)) {
                    this.toggle(true, null, () => {
                        this.check(this.content)
                    })
                }
            }, 500),

            deep: true
        }
    },
    computed: {
        content: {
            get() {
                return this.value
            },

            set(val) {
                this.check(val)
                this.$emit('input', val);
            }
        },

        constraints() {
            return this.field.constraints;
        },

        customData() {
            if (Object.keys(this.constraints.custom_data).length > 0) {
                return this.constraints.custom_data
            }
            
            return {
                daterange: {
                    is12h: false,
                    format: "yyyy-mm-dd",
                    disablePastDates: false,
                    disableFutureDates: false,
                    timePicker: false,
                    minuteStep: 1
                }
            }
        },

        dateFormat() {
            if (this.customData.daterange.timePicker) {
                return this.customData.daterange.format + " hh:mm"
            }

            return this.customData.daterange.format
        },

        minDate() {
            if (this.customData.daterange.disablePastDates) {
                return moment().format("yyyy-mm-dd")
            }

            return null
        },

        maxDate() {
            if (this.customData.daterange.disableFutureDates) {
                return moment().format("yyyy-mm-dd")
            }

            return null
        },
    },
    methods: {
        check(val) {
            this.errors = []

            if (!this.field.constraints.required) return this.$emit('input', val);

            let startDate = moment(val.startDate).format(this.dateFormat.toUpperCase())
            let endDate = moment(val.endDate).format(this.dateFormat.toUpperCase())

            if (val.startDate == null || val.endDate == null)  {
                 this.errors.push(this.translator("identityField.requiredField"))
            }

            if (this.disabledDates.indexOf(startDate) !== -1 || this.disabledDates.indexOf(endDate) !== -1) {
                this.errors.push(this.translator("identityField.invalidDates"))
            }
            
            this.$emit("error", {field: this.field.key, error: this.errors.length > 0})
        },

        formatter(classes, date) {
            date = moment(date).format(this.dateFormat.toUpperCase())

            if (!classes.disabled) {
                classes.disabled = this.disabledDates.indexOf(date) !== -1
            }

            return classes
        },

        getDatesBetween(startDate, endDate, includeEndDate) {
            const dates = [];
            const currentDate = startDate;
            while (currentDate < endDate) {
                dates.push(moment(currentDate).format(this.dateFormat.toUpperCase()));
                currentDate.setDate(currentDate.getDate() + 1);
            }
            if (includeEndDate) dates.push(moment(endDate).format(this.dateFormat.toUpperCase()));

            return dates;
        },

        toggle(show, f, callback) {
            if (show) {
                // reset disabled days
                this.disabledDates = []

                let componentUuid = this.store.getters.currentComponent.uuid
                let filters = buildFiltersFromContext(this.field.context, this.context)

                if (filters.filter != '' && filters.filterOn.length > 0) {
                    let date = moment()
                    let advancedFilter = {}
                    advancedFilter[this.field.key + ".startDate"] = {
                        $gte: "'ISODate(" + date.startOf('month').format(this.dateFormat.toUpperCase()) + ")'",
                    // $lte: "'ISODate(" + date.add(2, 'months').endOf('month').format(this.dateFormat.toUpperCase()) + ")'"
                    }

                    this.store.dispatch("field_DateRange_disabledDates", {
                        uuid: componentUuid,
                        config: {
                            field: this.field.key
                        },
                        context: {
                            $adv: {
                                ...advancedFilter
                            },
                            ...filters
                        }
                    }).then(resp => {
                        let items = resp.items

                        let dates = items.map(i => {
                            return i[this.field.key]
                        })

                        let self = this
                        dates.forEach(date => {
                            let datesBetween = this.getDatesBetween(new Date(Date.parse(date.startDate)), new Date(Date.parse(date.endDate)), true)
                            self.disabledDates = self.disabledDates.concat(datesBetween)
                        })

                        if (callback !== undefined) {
                            callback()
                        }
                    })
                }
            }
        }
    },
    mounted() {
        this.check(this.content)
    }
}
</script>